// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.wrapper {
  padding: 10px 0px;
  padding-bottom: 60px;
  overflow-x: hidden;
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  background-color: var(--background-default);
}
.wrapper .header-wrapper {
  text-align: center;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0px 20px;
}
.wrapper .title {
  font-family: AppFontBold, sans-serif;
  width: 100%;
  font-size: 22px;
  text-transform: uppercase;
  color: black;
  text-align: start;
  padding: 20px 0px 10px;
  text-align: center;
}
.wrapper .info-text {
  font-family: AppFont;
  font-size: 14px;
  color: black;
  padding: 5px 20px;
  text-align: center;
}
.wrapper ion-col .card-item {
  position: relative;
  margin: 0 auto;
  flex-grow: 1;
  min-height: 100%;
  word-break: break-word;
  background: white;
  border-radius: var(--custom-border-radius);
  box-shadow: 0px 2.1px 7.87px 0px rgba(79, 97, 79, 0.1490196078);
  transition: border 200ms linear;
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
}
.wrapper ion-col .card-item.selected {
  background: #F6FAF6;
  border: 2px solid var(--ion-color-primary);
}
.wrapper ion-col .card-item .image-block {
  width: 100%;
  position: relative;
  margin-bottom: 8px;
}
.wrapper ion-col .card-item .image-block ion-img {
  width: 100%;
  height: 100%;
  aspect-ratio: 512/371;
  object-fit: cover;
}
.wrapper ion-col .card-item .info-block {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  flex-grow: 1;
}
.wrapper ion-col .card-item .info-block .name {
  height: 44px;
  font-family: AppFontBold, sans-serif;
  font-weight: 600;
  font-size: 15px;
  margin: 0;
  display: flex;
  align-items: center;
  text-transform: uppercase;
  color: black;
  word-break: break-word;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}
@media (max-width: 992px) {
  .wrapper ion-col .card-item .info-block .name {
    font-size: 13px;
    height: 32px;
    overflow: hidden;
  }
}
.wrapper ion-col .card-item .quantity-selector {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  padding: 10px 0;
}
.wrapper ion-col .card-item .quantity-selector ion-icon {
  margin: 0px 6px;
  cursor: pointer;
}
.wrapper ion-col .card-item .quantity-selector .quantity {
  color: black;
  font-size: 20px;
  font-family: AppFontBold;
}
.wrapper ion-col .card-item .quantity-selector .quantity-btn {
  width: 30px;
  height: 30px;
}
.wrapper ion-col .card-item .quantity-selector .quantity-btn.add-opacity {
  opacity: 0.3;
  pointer-events: none;
}

.content_block {
  height: calc(100% - 94px);
  overflow-y: auto;
  width: 100%;
  padding: 30px;
  background: black url('modal-info.png') no-repeat center center/100% 100%;
}

.footer-btn {
  position: fixed;
  bottom: 20px;
  left: 0px;
  right: 0px;
  width: 100%;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
}
.footer-btn ion-button {
  margin: 5px 0px;
  width: 90%;
  text-transform: uppercase;
  color: #fff;
  font-size: 16px;
  font-size: 15px;
  min-height: 36px;
}
.footer-btn ion-button.cancel-btn {
  --background: var(--ion-color-primary);
  color: white;
}
.footer-btn ion-button:disabled {
  opacity: 0.5;
}`, "",{"version":3,"sources":["webpack://./src/app/components/selection-multiple-free-articles/selection-multiple-free-articles.component.scss","webpack://./src/theme/mixins.scss"],"names":[],"mappings":"AAEA;EACC,iBAAA;EACA,oBAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,2BAAA;EACA,2CAAA;AADD;AAEC;EACC,kBAAA;EACA,WAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,iBAAA;AAAF;AAEC;EACC,oCAAA;EACA,WAAA;EACA,eAAA;EACA,yBAAA;EACA,YAAA;EACA,iBAAA;EACA,sBAAA;EACA,kBAAA;AAAF;AAEC;EACC,oBAAA;EACA,eAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;AAAF;AAGE;EACC,kBAAA;EACA,cAAA;EACA,YAAA;EACA,gBAAA;EACA,sBAAA;EACA,iBAAA;EACA,0CAAA;EACA,+DAAA;EACA,+BAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,8BAAA;EACA,mBAAA;AADH;AAEG;EACC,mBAAA;EACA,0CAAA;AAAJ;AAEG;EACC,WAAA;EACA,kBAAA;EACA,kBAAA;AAAJ;AACI;EACC,WAAA;EACA,YAAA;EACA,qBAAA;EACA,iBAAA;AACL;AAEG;EACC,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,8BAAA;EACA,YAAA;AAAJ;AACI;EACC,YAAA;EACA,oCAAA;EACA,gBAAA;EACA,eAAA;EACA,SAAA;EACA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,YAAA;EACA,sBAAA;EACA,oBAAA;EACA,qBAAA;EACA,4BAAA;EACA,gBAAA;EACA,uBAAA;AACL;ACpFE;EDoEE;IAiBE,eAAA;IACA,YAAA;IACA,gBAAA;EAGJ;AACF;AAAG;EACC,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,WAAA;EACA,eAAA;AAEJ;AADI;EACC,eAAA;EACA,eAAA;AAGL;AADI;EACC,YAAA;EACA,eAAA;EACA,wBAAA;AAGL;AADI;EACC,WAAA;EACA,YAAA;AAGL;AAFK;EACC,YAAA;EACA,oBAAA;AAIN;;AAGA;EACC,yBAAA;EACA,gBAAA;EACA,WAAA;EACA,aAAA;EACA,yEAAA;AAAD;;AAEA;EACC,eAAA;EACA,YAAA;EACA,SAAA;EACA,UAAA;EACA,WAAA;EACA,aAAA;EACA,uBAAA;EACA,sBAAA;EACA,mBAAA;AACD;AAAC;EACC,eAAA;EACA,UAAA;EACA,yBAAA;EACA,WAAA;EACA,eAAA;EAKA,eAAA;EACA,gBAAA;AAFF;AAHE;EACC,sCAAA;EACA,YAAA;AAKH;AADE;EACC,YAAA;AAGH","sourcesContent":["@import '../../../theme/mixins';\n\n.wrapper {\n\tpadding: 10px 0px;\n\tpadding-bottom: 60px;\n\toverflow-x: hidden;\n\theight: 100%;\n\twidth: 100%;\n\tdisplay: flex;\n\tflex-direction: column;\n\talign-items: flex-start;\n\tjustify-content: flex-start;\n\tbackground-color: var(--background-default);\n\t.header-wrapper {\n\t\ttext-align: center;\n\t\twidth: 100%;\n\t\tdisplay: flex;\n\t\tjustify-content: center;\n\t\talign-items: center;\n\t\tpadding: 0px 20px;\n\t}\n\t.title {\n\t\tfont-family: AppFontBold, sans-serif;\n\t\twidth: 100%;\n\t\tfont-size: 22px;\n\t\ttext-transform: uppercase;\n\t\tcolor: black;\n\t\ttext-align: start;\n\t\tpadding: 20px 0px 10px;\n\t\ttext-align: center;\n\t}\n\t.info-text {\n\t\tfont-family: AppFont;\n\t\tfont-size: 14px;\n\t\tcolor: black;\n\t\tpadding: 5px 20px;\n\t\ttext-align: center;\n\t}\n\tion-col {\n\t\t.card-item {\n\t\t\tposition: relative;\n\t\t\tmargin: 0 auto;\n\t\t\tflex-grow: 1;\n\t\t\tmin-height: 100%;\n\t\t\tword-break: break-word;\n\t\t\tbackground: white;\n\t\t\tborder-radius: var(--custom-border-radius);\n\t\t\tbox-shadow: 0px 2.1px 7.87px 0px #4F614F26;\n\t\t\ttransition: border 200ms linear;\n\t\t\ttext-align: center;\n\t\t\tdisplay: flex;\n\t\t\tflex-direction: column;\n\t\t\tjustify-content: space-between;\n\t\t\talign-items: center;\n\t\t\t&.selected {\n\t\t\t\tbackground: #F6FAF6;\n\t\t\t\tborder: 2px solid var(--ion-color-primary);\n\t\t\t}\n\t\t\t.image-block {\n\t\t\t\twidth: 100%;\n\t\t\t\tposition: relative;\n\t\t\t\tmargin-bottom: 8px;\n\t\t\t\tion-img {\n\t\t\t\t\twidth: 100%;\n\t\t\t\t\theight: 100%;\n\t\t\t\t\taspect-ratio: 512 / 371;\n\t\t\t\t\tobject-fit: cover;\n\t\t\t\t}\n\t\t\t}\n\t\t\t.info-block {\n\t\t\t\tdisplay: flex;\n\t\t\t\tflex-direction: column;\n\t\t\t\talign-items: center;\n\t\t\t\tjustify-content: space-between;\n\t\t\t\tflex-grow: 1;\n\t\t\t\t.name {\n\t\t\t\t\theight: 44px;\n\t\t\t\t\tfont-family: AppFontBold, sans-serif;\n\t\t\t\t\tfont-weight: 600;\n\t\t\t\t\tfont-size: 15px;\n\t\t\t\t\tmargin: 0;\n\t\t\t\t\tdisplay: flex;\n\t\t\t\t\talign-items: center;\n\t\t\t\t\ttext-transform: uppercase;\n\t\t\t\t\tcolor: black;\n\t\t\t\t\tword-break: break-word;\n\t\t\t\t\tdisplay: -webkit-box;\n\t\t\t\t\t-webkit-line-clamp: 2;\n\t\t\t\t\t-webkit-box-orient: vertical;\n\t\t\t\t\toverflow: hidden;\n\t\t\t\t\ttext-overflow: ellipsis;\n\t\t\t\t\t@include mobile {\n\t\t\t\t\t\tfont-size: 13px;\n\t\t\t\t\t\theight: 32px;\n\t\t\t\t\t\toverflow: hidden;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t\t.quantity-selector {\n\t\t\t\tdisplay: flex;\n\t\t\t\tjustify-content: center;\n\t\t\t\talign-items: center;\n\t\t\t\twidth: 100%;\n\t\t\t\tpadding: 10px 0;\n\t\t\t\tion-icon {\n\t\t\t\t\tmargin: 0px 6px;\n\t\t\t\t\tcursor: pointer;\n\t\t\t\t}\n\t\t\t\t.quantity {\n\t\t\t\t\tcolor: black;\n\t\t\t\t\tfont-size: 20px;\n\t\t\t\t\tfont-family: AppFontBold;\n\t\t\t\t}\n\t\t\t\t.quantity-btn {\n\t\t\t\t\twidth: 30px;\n\t\t\t\t\theight: 30px;\n\t\t\t\t\t&.add-opacity {\n\t\t\t\t\t\topacity: 0.3;\n\t\t\t\t\t\tpointer-events: none;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}\n.content_block {\n\theight: calc(100% - 94px);\n\toverflow-y: auto;\n\twidth: 100%;\n\tpadding: 30px;\n\tbackground: black url('../../../assets/losteria/modal-info.png') no-repeat center center / 100% 100%;\n}\n.footer-btn {\n\tposition: fixed;\n\tbottom: 20px;\n\tleft: 0px;\n\tright: 0px;\n\twidth: 100%;\n\tdisplay: flex;\n\tjustify-content: center;\n\tflex-direction: column;\n\talign-items: center;\n\tion-button {\n\t\tmargin: 5px 0px;\n\t\twidth: 90%;\n\t\ttext-transform: uppercase;\n\t\tcolor: #fff;\n\t\tfont-size: 16px;\n\t\t&.cancel-btn {\n\t\t\t--background: var(--ion-color-primary);\n\t\t\tcolor: white;\n\t\t}\n\t\tfont-size: 15px;\n\t\tmin-height: 36px;\n\t\t&:disabled {\n\t\t\topacity: 0.5;\n\t\t}\n\t}\n}\n","@mixin desktop {\n  @media (min-width: 991px) {\n    @content;\n  }\n}\n\n@mixin mobile {\n  @media (max-width: 992px) {\n    @content\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
